<template>
  <div>
    <Card>
      <template slot="header">Financial report</template>
      <v-layout column>
        <v-layout justify-center>
          <v-menu
            :nudge-right="30"
            transition="scale-transition"
            offset-y
            min-width="290px"
            @input="update()"
          >
            <v-text-field
              slot="activator"
              v-model="dateRange.startDate"
              label="Start Date"
              prepend-icon="event"
              readonly
            />
            <v-date-picker v-model="dateRange.startDate"/>
          </v-menu>
          <v-menu
            :nudge-right="30"
            transition="scale-transition"
            offset-y
            min-width="290px"
            @input="update()"
          >
            <v-text-field
              slot="activator"
              v-model="dateRange.endDate"
              label="End Date"
              prepend-icon="event"
              readonly
            />
            <v-date-picker v-model="dateRange.endDate"/>
          </v-menu>
        </v-layout>
        <v-layout
          align-center
          column
        >
          <v-flex>
            <v-tabs
              v-model="filter.account"
              fixed-tabs
            >
              <v-tabs-slider/>
              <v-tab href="#">
                <v-icon left>fa-asterisk</v-icon>All
              </v-tab>
              <v-tab href="#payment">
                <v-icon left>fa-credit-card</v-icon>Payments
              </v-tab>

              <v-tab href="#revenueStream">
                <v-icon left>fa-code-branch</v-icon>Streams
              </v-tab>

              <v-tab href="#baxterBuck">
                <v-icon left>fa-money-bill-alt</v-icon>Baxter Bucks
              </v-tab>
              <v-tab href="#refund">
                <v-icon left>fa-hand-holding-usd</v-icon>Refund
              </v-tab>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-layout>
    </Card>
    <v-card>
      <v-card-title>
        <CSVDownload :data="filteredAccountEntries"/>
        <v-spacer/>
        <v-switch
          v-model="filter.clerkOnly"
          label="Only Mine"
        />
        <v-spacer/>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-data-table
        ref="financial"
        :headers="headers"
        :items="filteredAccountEntries"
        :search="search"
        disable-initial-sort
        class="elevation-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>{{ props.item.accountEntryID }}</td>
          <td>{{ props.item.accountID }}</td>
          <td>{{ props.item.accountEntryTypeID }}</td>
          <td>{{ props.item.invoiceID }}</td>
          <td>{{ props.item.firstName }} {{ props.item.lastName }} ({{ props.item.personID }})</td>
          <td>{{ props.item.adminLastName }}</td>
          <td class="text-xs-right">${{ props.item.debit }}</td>
          <td class="text-xs-right">${{ props.item.credit }}</td>
          <td class="text-xs-right">{{ props.item.timestamp }}</td>
        </template>
        <template
          slot="footer"
        >
          <tr class="font-weight-bold grey lighten-3">
            <td
              colspan="3"
              class="text-xs-right"
            >
              <v-select
                v-model="sumType"
                :items="['visible', 'all']"
                label="Sum"
              />
            </td>
            <td
              colspan="3"
              class="text-xs-right"
            >
              Entry Totals:
            </td>
            <td class="text-xs-right">${{ totals.debit.toFixed(2) }}</td>
            <td class="text-xs-right">${{ totals.credit.toFixed(2) }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      search: '',
      filter: {
        account: 0,
        clerkOnly: false
      },
      headers: [
        {
          text: 'EntryID',
          align: 'left',
          sortable: true,
          value: 'accountEntryID'
        },
        {
          text: 'accountID',
          align: 'left',
          sortable: true,
          value: 'accountID'
        },
        {
          text: 'accountEntryTypeID',
          align: 'left',
          sortable: true,
          value: 'accountEntryTypeID'
        },
        {
          text: 'invoiceID',
          align: 'left',
          sortable: true,
          value: 'invoiceID'
        },
        {
          text: 'Camper',
          align: 'left',
          sortable: true,
          value: 'personID'
        },
        {
          text: 'Admin',
          align: 'left',
          sortable: true,
          value: 'adminID'
        },
        {
          text: 'Debit',
          align: 'right',
          sortable: true,
          value: 'debit'
        },
        {
          text: 'Credit',
          align: 'right',
          sortable: true,
          value: 'credit'
        },
        {
          text: 'Timestamp',
          align: 'right',
          sortable: true,
          value: 'timestamp'
        }
      ],
      filteredItems: [],
      sumType: 'visible'
    }
  },
  computed: {
    ...mapGetters({
      dateRange: 'reports/dateRange',
      accountEntries: 'reports/accountEntries',
      primaryPerson: 'person/primaryPerson'
    }),
    filteredAccountEntries () {
      let accountEntries = this.accountEntries
      // filter by account
      if (this.filter.account) {
        accountEntries = accountEntries.filter((entry) => entry.accountID === this.filter.account)
      }
      // filter to clerkOnly
      if (this.filter.clerkOnly) {
        accountEntries = accountEntries.filter((entry) => entry.adminID === this.primaryPerson.personID)
      }
      return accountEntries
    },
    totals () {
      let initialTotals = {
        credit: 0,
        debit: 0
      }
      let items = (this.sumType === 'all' ? this.filteredAccountEntries : this.filteredItems)
      let calculatedTotals = items?.reduce((total, entry) => {
        return {
          credit: total.credit + Number(entry.credit),
          debit: total.debit + Number(entry.debit)
        }
      }, initialTotals)
      return calculatedTotals || initialTotals
    }
  },
  mounted () {
    this.getAccountEntries()
    this.$watch(
      () => {
        return this.$refs.financial.filteredItems
      },
      (val) => {
        console.log(this.$refs.financial)
        this.filteredItems = this.$refs.financial.filteredItems
      }
    )
  },
  methods: {
    ...mapActions({
      updateDateRange: 'reports/updateDateRange',
      getAccountEntries: 'reports/getAccountEntries'
    }),
    update () {
      this.updateDateRange(this.dateRange)
      this.getAccountEntries()
    },
    setAccountFilter (type) {
      this.filter.account = type
    },
    setScopeFilter (scope) {
      this.filter.scope = scope
    }
  }
}
</script>
